module.exports = __webpack_public_path__ + "assets/img/en.17988fe4.png";